import React, { Component, Fragment, useState } from "react";
import { Form, Accordion, Card } from "react-bootstrap";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import CheckBoxChecked from "../../images/check_box_checked.svg";
import CheckBoxUnCheck from "../../images/check_box_uncheck.svg";

import SpanMoreTabDown from "../../images/chevron-down-small.svg";
import SpanMoreTabTop from "../../images/chevron-top.svg";
import InfoChecked from "../../images/info_icon/checked.svg";

function CustomToggle({ init, children, eventKey }) {
  const decoratedOnClick = useAccordionToggle(eventKey);
  const [toggle, setToggle] = useState(false);

  const onToggle = e => {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    setToggle(!toggle);
    decoratedOnClick();
  };

  const forceAction = toggleValue => {
    if (!toggle) {
      setToggle(toggleValue);
      decoratedOnClick();
    }
  };

  if (init) {
    init(forceAction);
  }

  return (
    <div className="accordion-toggle" name="toggle" onClick={e => onToggle(e)}>
      {children}
      <img
        src={toggle ? SpanMoreTabTop : SpanMoreTabDown}
        width="16px"
        height="16px"
        alt="span image"
      />
    </div>
  );
}

const InfoItemDetail = props => {
  return (
    <div className="d-flex item-detail">
      <img src={InfoChecked} width="24px" height="24px" />
      <p className="text-educate">{props.children}</p>
    </div>
  );
};

export default class CheckBoxInsurance extends Component {
  state = {
    isToggle: false,
    checked: false
  };
  callBackAction;

  constructor(props) {
    super(props);
    this.state.checked = props.checked;
  }

  _onCheckChange = () => {
    const { checked, isToggle } = this.state;
    const { onCheckChange } = this.props;
    const next = !checked;
    if (next) {
      this.callBackAction(true);
    }
    this.setState({ ...this.state, checked: next }, res => {
      if (onCheckChange) {
        onCheckChange(next);
      }
    });
  };
  _onCollasped = isToggle => {
    this.setState({ ...this.state, isToggle: isToggle });
  };

  _onToggleInit = callBackAction => {
    if (callBackAction) {
      this.callBackAction = callBackAction;
    }
  };

  render() {
    const { checked } = this.state;
    const imgSource = checked ? CheckBoxChecked : CheckBoxUnCheck;
    return (
      <Fragment>
        <Accordion className="checkbox-wrapper">
          <Form.Group className="d-flex">
            <div
              className="d-flex align-item-center"
              onClick={this._onCheckChange}
            >
              <img
                src={imgSource}
                className="mr-2"
                width="24px"
                height="24px"
              />
              <p className="mb-0">ข้าพเจ้าตกลงทำประกันภัย</p>
            </div>
            <CustomToggle eventKey="1" init={this._onToggleInit}>
              <p>ตามเงื่อนไข</p>
            </CustomToggle>
          </Form.Group>
          <Accordion.Collapse eventKey="1">
            <Fragment>
              <p className="text-educate">
                ข้าพเจ้าได้อ่านและเข้าใจเงื่อนไขความคุ้มครองโดยตลอดจึงตกลงขอซื้อประกันภัยกับ
                บริษัท เมืองไทยประกันภัย จำกัด (มหาชน)
                ตามรายละเอียดในคำขอเอาประกันภัยดังกล่าวข้างต้น
              </p>
            </Fragment>
          </Accordion.Collapse>
        </Accordion>
      </Fragment>
    );
  }
}
